import { CssModifiers } from './'

const dom = document.documentElement
const STATE = 'm-scroll-locked'

const lock = () => CssModifiers.add(dom, STATE)
const release = () => CssModifiers.remove(dom, STATE)

const ScrollLock = { lock, release }
export default ScrollLock



// WEBPACK FOOTER //
// ./js/utils/ScrollLock.js